import * as React from 'react'
import classNames from 'classnames'
import style from './style.module.css'
import {useCallback, useEffect, useRef, useState} from "react";

let bridge: {
  show?:(config:ActionSheetConfig) => any,
  hide?:() => any
} = {}

// 暴露给用户调用的方法
export function showActionSheet(config:ActionSheetConfig) {
  if (bridge.show) {
    bridge.show({...config})
  }
}
export function hideActionSheet(){
  if (bridge.hide){
    bridge.hide()
  }
}

interface ActionSheetConfig{
  actionClass?:string,
  title?:string | JSX.Element,
  subtitle?:string,
  menu?:Array<Menu>,
  content?:JSX.Element,
  action?:Action,
  activeColor?:string,
  activeIndex?:number,
  zIndex?:number,
  hasRadius?:boolean,
  scrollUnChange?:boolean,
  hideCallback?:()=>any
}

interface Menu{
  name:string | JSX.Element,
  subName?:string | JSX.Element,
  onClick:() => any
}

interface Action {
  text:string,
  onClick?:() => any,
  className?:string
}

export function ActionSheet() {
  const [activeIndex,setActiveIndex] = useState(0)
  const [isShow,setIsShow] = useState(false)
  const [config,setConfig] = useState<ActionSheetConfig | null>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const [isHide,setIsHide] = useState(false)
  const timer = useRef<any>(null)
  const [hideTime,setHideTime] = useState(0)

  useEffect(()=>{
    bridge = {show,hide}

    return()=>{
      bridge = {}
      timer.current && clearTimeout(timer.current)
    }
  },[hideTime])

  const show = (config:ActionSheetConfig)=>{
    //动画时间点击不生效
    const time = new Date().getTime()  - hideTime
    if(time <= 300) return
    setIsHide(false)
    setActiveIndex(config.activeIndex || 0)
    setIsShow(true)
    setConfig(config)

    if(config && !config.scrollUnChange){
      //如果menu的scrollTop > 0 滚动条位置设置为0
      const scrollTop = contentRef && contentRef.current && contentRef.current.scrollTop || 0
      if(scrollTop > 0 && contentRef && contentRef.current){
        contentRef.current.scrollTop = 0
      }
    }
  }

  const hide = useCallback(()=>{
    setHideTime(new Date().getTime())
    setIsShow(false)
    timer.current = Number(setTimeout(()=>{//隐藏的时候透明度为0 防止上拉看到隐藏的部分
      setIsHide(true)
    },300))
  },[isHide,config,hideTime])

  const clickMenuItem = useCallback((item:Menu,index:number)=>{
    if(index === activeIndex && config && config.title) return
    item.onClick && item.onClick();
    setActiveIndex(index)
  },[activeIndex])

  return(
    <div className={style['action-sheet-box']}
      style={{opacity:isShow?1:0}}
      id='weike-ui-action-sheet'
    >
      <div className={style['mask']}
        onClick={()=>{
          if(config && config.hideCallback){
            config.hideCallback()
          }else{
            hide()
          }
        }}
        style={{
          opacity:isShow?1:0,
          display:isShow?'block':'none',
          zIndex:config ? config.zIndex || 100 : 100
        }}
      >
      </div>
      <div
        className={
          classNames(style['action-sheet'],
          isShow ? style['action-sheet_toggle'] : '')
        }
        style={{
          opacity:isHide?0:1,
          zIndex:config ? config.zIndex ? config.zIndex+1 : 101 : 101
        }}
      >
        {
          config && <div className={style['action-sheet-width']}>
            <div className={
              classNames(
                config.hasRadius && style['action-sheet-has-radius'],
                style['action-sheet-main']
              )
            }>
              {
                config.title && <div className={style['action-sheet-title-box']}>
                  <div className={style['action-sheet-title-bar']}></div>
                  {
                    config.subtitle ?
                      <div className={style['action-sheet-title']}>
                        <span className={style['headline']}>{config.title}</span>
                        <span className={style['subtitle']}>{config.subtitle}</span>
                      </div>:
                      <div className={style['action-sheet-title']}>
                        <div className={style['only-title']}>{config.title}</div>
                      </div>
                  }
                </div>
              }
              <div
                className={
                  classNames(
                    style['action-sheet-content'],
                    config.title ? style['action-sheet-content-has-title'] :
                      style['action-sheet-content-no-title'],
                    config.actionClass
                  )
                }
                ref={contentRef}
              >
                {
                  config.menu && config.menu.length > 0 && config.menu.map((item:Menu,index:number)=>{
                    return <div
                      key={index}
                      className={
                        classNames(
                          style['action-sheet-menu-item'],
                          config.title ? style['menu-item-has-title'] :
                            style['menu-item-no-title']
                        )
                      }
                      onClick={()=>clickMenuItem(item,index)}
                      style={{
                        color:activeIndex === index && config.title ?
                          config.activeColor ? config.activeColor : '#FF5A31'
                          : ''
                      }}
                    >
                      <div style={{width:config.title ? '100%' : '' }}>
                        {item.name}
                        {
                          !config.title && item.subName &&
                          <div className={style['sub-name']}>{item.subName}</div>
                        }
                      </div>
                    </div>
                  })
                }
                {
                  config.content && <div style={{padding:'0 20px'}}>{config.content}</div>
                }
              </div>
            </div>
            {
              config.action &&
              <div className={classNames(style['action-sheet-action'],config.action.className)} onClick={()=>{
                config.action && config.action.onClick && config.action.onClick()
              }}>
                {config.action.text}
              </div>
            }
          </div>
        }
      </div>
    </div>
  )
}




// WEBPACK FOOTER //
// ../src/action-sheet/index.tsx